import { makeAutoObservable } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { MenuStore } from 'widgets/Menu/store/menuStore'
import { menuItems } from 'widgets/Menu/ui/MenuAnalytics/constants/menuItems'

export class MenuAnalyticsStore {
  private readonly _menuStore: MenuStore

  constructor(key: string, private _entities: IEntitiesStore) {
    makeAutoObservable(this)

    this._menuStore = new MenuStore(
      {
        key: key,
      },
      this._entities
    )
  }

  get menuStore() {
    return this._menuStore
  }

  get menuItems() {
    return menuItems
  }
}
